import { render, staticRenderFns } from "./NoContentContainer.vue?vue&type=template&id=0bc5129c&scoped=true&"
import script from "./NoContentContainer.vue?vue&type=script&lang=ts&"
export * from "./NoContentContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5129c",
  null
  
)

export default component.exports